module.exports = __webpack_public_path__ + "static/media/shiftscheduling.ca69cb0d.webp";